import Controller from '@ember/controller';
import { service } from '@ember/service';
import type ChatService from 'walden-fast/services/chat';

export default class AppContactChatController extends Controller {
  @service('chat') declare chat: ChatService;

  activateModalName = 'activate-chat';

  get currentDate() {
    return new Date();
  }
}
